import get from 'lodash/get';
import each from 'lodash/each';
import replace from 'lodash/replace';
import isNull from 'lodash/isNull';
import marketingDictionary from './marketingDictionary';

const delimiter = '--';

/**
 * assembles a payload from the vuex state
 *
 * @param state
 * @returns {{custom: {}}}
 */
export function buildPayloadFromState (state) {
  const payload = {
    custom: {}
  };

  each(marketingDictionary, (dictionaryItem, key) => {
    let value = get(state, key, null);

    if (!isNull(value) || dictionaryItem.type === 'boolean') {
      if (typeof dictionaryItem.mutate === 'function') {
        value = dictionaryItem.mutate(value);
      }

      if (!dictionaryItem.custom) {
        payload[dictionaryItem.fieldName] = typeCast(dictionaryItem.type, value);
      } else {
        payload.custom[dictionaryItem.type + delimiter + delimit(dictionaryItem.fieldName)] = typeCast(dictionaryItem.type, value);
      }
    }
  });

  return payload;
}

/**
 * Returns the value cast as a type
 *
 * @param type
 * @param value
 * @returns {*}
 */
function typeCast (type, value) {
  switch (type) {
    case 'string' :
      return `${value}`;
    case 'boolean' :
      return !!(value);
    case 'integer' :
      return parseInt(value);
    case 'float': return parseFloat(value);
    default:
      return value;
  }
}

/**
 * Build the delimiter for custom field keys
 *
 * @param customFieldKey
 * @returns {string}
 */
function delimit (customFieldKey) {
  return replace(customFieldKey, ' ', delimiter);
}
